<template>
  <div
    class="dropzone"
    @dragenter="onDragEnter"
    @dragover="onDragOver"
    @dragleave="onDragLeave"
    @drop="onDrop"
    :class="{
      'dragover': isDragover
    }"
  >
    <slot></slot>
    <div :class="{
      'visible': isDragover
    }" class="backdrop">
      <div class="hormid">
        <div class="vermid">
          <img class="dt-icon v7 drop-icon" src="static/icons/add-icon-large.svg" alt />
          <span class="drop-text" >
            Drop to Upload File
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { preventAndStop } from "../../utility";

export default {
  data: function() {
    return {
      isDragover: false
    };
  },
  methods: {
    onDragEnter: function(event) {
      this.isDragover = true;
      preventAndStop(event);
    },
    onDragOver: function(event) {
      this.isDragover = true;
      preventAndStop(event);
    },
    onDragLeave: function(event) {
      this.isDragover = false;
      preventAndStop(event);
    },
    onDrop: function(event) {
      preventAndStop(event);
      this.isDragover = false;

      const files = event.dataTransfer.files;

      if (files.length > 0) {
        this.$emit("filedrop", files);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dropzone {
  position: relative;
  padding: 0px !important;
  height: inherit !important;
  .backdrop {
    background: rgba(255, 255, 255, 0.76);
    position: absolute;
    width: 100%;
    top: -20px;
    height: 107%;

    transition: 200ms ease-out;

    border: 2px dashed black;
    border-radius: 30px;

    opacity: 0.0;
    z-index: -1;

    .drop-icon {
      width:  55px;
      height: 55px;

      margin-right: auto;
      margin-left: auto;
    }

    .drop-text {
      margin-top: 20px;
    }

    &.visible {
      opacity: 1;
      z-index: 1;
    }
  }
}
</style>
